/**
 * Constants for MsMultipleSelectButton component
 */

// Valid button types
export const VALID_MULTIPLE_SELECT_BUTTON_TYPES = [
  'primary',
  'secondary', 
  'third',
  'four'
]

// Default props values
export const DEFAULT_PROPS = {
  text: null,
  leftIcon: null,
  rightIcon: 'chevron-down-white',
  type: 'primary',
  disabled: false,
  data: [],
  classCustom: '',
  customPositionMenu: false,
  customWidth: 0,
  heightOffset: 5,
  widthOffset: 25,
  hasShowMenu: true,
  tooltipText: null,
  hasBorder: false,
  hasBorderParent: false,
  valueField: 'key',
  displayField: 'value',
  modelValue: ''
}

// CSS class names - separating into individual classes for better testing
export const CSS_CLASSES = {
  // Base classes
  MULTIPLE_SELECT_BUTTON: 'mutiple-select-button',
  FLEX_CENTER: 'flex-center',
  
  // State classes
  BORDER_PARENT: 'border-split-btn',
  
  // Widget classes
  WIDGET_MORE_CONTAINER: 'widget-more-container',
  WIDGET_BTN: 'widget-btn',
  WIDGET_ROOT_CLASS: 'mutiple-select-widget-more-container',
  
  // Button classes
  BTN: 'btn',
  FLEX_ROW: 'flex-row',
  PRIMARY_BUTTON: 'primary-button',
  BORDER_NONE: 'btn-border-none',
  
  // Option item classes
  OPTION_ITEM: 'flex-row option-item',
  CELL_CHECKBOX: 'cell-checkbox',
  ICON: 'icon',
  CHECKED: 'checked'
}

// Event names
export const EVENTS = {
  MENU_CLICK: 'menuClick',
  UPDATE_SELECTED: 'update:selected'
}

// Field mapping defaults
export const FIELD_MAPPING = {
  VALUE_FIELD: 'key',
  DISPLAY_FIELD: 'value'
}
